import {RequestInfo, RequestKeys} from "../../../shared-components/constants/requests"
import * as fromRequests from "../../../shared-components/store/requests/requestsReducer"
import * as sapStorage from "../../localStorage/sapReducer"

/**
 * Get the style from the store.
 */
export const getStyle = (state, contractId) => sapStorage.getStyle(state.localStorage.sap, contractId)
/**
 * Is the application fetching style ?
 */
export const isFetchingStyle = state =>
    fromRequests.isFetching(RequestInfo[RequestKeys.RETRIEVE_STYLE].name, state.requests)
/**
 * Is style customized ?
 */
export const areCustomizedStyle = (state, contractId) =>
    sapStorage.isCustomizedStyle(state.localStorage.sap, contractId)
